import { Component, inject, ViewChild } from '@angular/core';
import { CompanySearchComponent } from 'components/core/company-search/company-search.component';
import { ButtonComponent } from 'components/input/button/button.component';
import { ListViewComponent } from 'components/layout/list-view/list-view.component';
import { CredentialType } from 'enums/CredentialType';
import { DomainModel } from 'models/generated/Distribution.Api.Models.Domain';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CompanyService } from 'services/company.service';
import { CredentialRequired } from 'services/credential.service';
import { DomainService } from 'services/domain.service';
import { ComponentUrl } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';

@Component({
	selector: 'clean-up-domains',
	templateUrl: './clean-up-domains.component.html',
	imports: [Layout, ListView, CompanySearchComponent, TranslatePipe]
})
@ComponentUrl('clean-up-domains')
@CredentialRequired(CredentialType.DomainCleanUp)
export class CleanUpDomainsComponent {

	@ViewChild(ListViewComponent) domainList?: ListViewComponent;
	@ViewChild('removeDomainButton') removeDomainButton?: ButtonComponent;
	@ViewChild('moveButton') submitButton?: ButtonComponent;

	selectedDomain?: DomainModel;
	domains?: DomainModel[];
	selectedCompanyId?: string;
	companyInfo?: CompanyModel;

	private readonly domainService = inject(DomainService);
	private readonly companyService = inject(CompanyService);
	private readonly notificationService = inject(NotificationService);
	
	constructor() {
		this.loadDomains();
	}

	async loadDomains() {
		this.domains = await this.domainService.getDomainsNeedingCleanup();
	}

	async selectCompany(companyId: string) {
		this.selectedCompanyId = companyId;
		this.companyInfo = await this.companyService.getCompany(companyId);
	}

	async moveToSelectedCompany() {
		if (!this.selectedDomain?.id || !this.companyInfo || !this.selectedCompanyId) return;
		const domain = this.selectedDomain;

		await this.domainService.moveDomainToCompany(domain.id!, this.selectedCompanyId);
		this.submitButton?.reset();
		this.selectedDomain.$deleted = true;
		if (this.selectedDomain == domain) this.domainList?.selectNextRow();
	}

	removeDomain() {
		if (!this.selectedDomain?.id) return;
		const domain = this.selectedDomain;
		this.notificationService.confirm('company.domains.remove-confirm', { 'domain': this.selectedDomain.name }).subscribe(async confirmed => {
			if (confirmed) {
				await this.domainService.removeDomain(domain.id!);
				this.removeDomainButton?.reset();
				domain.deleted = new Date();
				domain.$deleted = true;
				if (this.selectedDomain == domain) this.domainList?.selectNextRow();
			}
			else
				this.removeDomainButton?.reset();
		});
	}

}
